import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import SriyanshCardHeader from "../../components/CardHeader";
import {DISPLAY_PAGE_SIZE} from "../../constants/constants"
import CircularProgress from "@mui/material/CircularProgress";
import "../../css/App.css";
import "../../css/color.css";
import _ from "lodash";
import TokenService from "../../service/TokenService";
import ExportToExcelCustomButton from "../../components/ExportToExcelButtonCustom";

import SearchTextField from "../../CustomComponant/SearchTextField";
import ListDynamicTable from "../../CustomComponant/ListDynamicTable";
import ExportToPDFCustomButton from "../../components/ExportPDFfromTable.js";

//const moment = require("moment");

function ReceivedItemList() {
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [srcinddata, setSrcinddata] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;

  const [reportData, setReportData] = useState([]);

  const handleRowClick = (row) => {
    // Handle row click action with the row data
    viewData(row.entrynumber);
    //  console.log('Row data:', row);
  };

  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      //setPageLoader(true);
      try {
        const response = await apiClient.post("/getitemNotReceivedList", {
          uname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);

        const allDataResponse = await apiClient.post("/getitemNotReceivedList", {
          uname: uname,
          limit: "0", // No limit
          offset: "0", // No offset
          srcinddata: "", // No search term for fetching all data
        });

        setReportData(allDataResponse.data);
      } catch (error) {
        setReportData([]);
        setReturnData([]);
        setTotalRows(0);
      }finally
      {
        setPageLoader(false);
      }
    }, 300),
    [uname, currentPage, pageSize]
  );

  useEffect(() => {
    fetchData(srcinddata);
  }, [srcinddata, fetchData]);

  const viewData = (e) => {
   // alert(e);
    navigate("receiveditementry", {
      state: {
        indent_id: e,
      },
    });
  };

  const columns = [
    "Shop",
    "party_name",
    //"party_contact",
    "IndentNumber",
    "ponumber",
    "podate",
    "daydiff",
    "DPdate",
    "poitemname",
  ]; // keys from your data objects
  const columnNames = [
    "Consignee",
    "Supplier",
    //"Party Contact",
    "Indent Number",
    "PO Number",
    "PO Date",
    "Panding Days from PO",
    "DP Date",
    "Item Name",
  ];

  return (
    <div>
     
      <Card className="Formcard">

      <div className="input-groupHeading">
      PO List which Item not Received

            </div>




        <CardContent>
          {/*-----------------------SEARCH BOX--------------------*/}

          {currentPage === 1 ? (
            <SearchTextField
              label="PO Number"
              value={srcinddata}
              title="Enter PO Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search PO">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

          {pageLoader ? (
            <div className="loaderContainer">
              {" "}
              <CircularProgress />{" "}
            </div>
          ) : (
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={returnData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onRowClick={handleRowClick}
            />
          )}

          {/* -----------------------Export Button---------------------------------------- */}
          <div className="container mt-4"></div>
          <div className="mb-3 mt-2  container col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              data={reportData}
              fileName={"Item Received"} // PAGE NO. :" + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to Excel"
            />

            <ExportToPDFCustomButton
              data={reportData}
              fileName={"Item Received"} // PAGE NO. :" + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to PDF"
              pageHeader="PO List which Item not Received"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ReceivedItemList;
